import React from 'react';
import IntroCmp from '../IntroComponent/IntroComp' 
import FrameName from '../FrameName/FrameName' 
import AboutMe from '../AboutMe/AboutMe' 
import MindsetComp from '../MindsetComp/MindsetComp';
import SkillsComp from '../SkillsComp/SkillsComp'
import ProjectComp from '../ProjectsComp/ProjectComp'
import ContactsComp from '../ContactsComp/ContactsComp'
import FooterComp from '../FooterComp/FooterComp'
import './mainStyle.css'

const MainComponent = () =>{
    return(
        <div className='s_main'>
            {/* <NavBar /> */}
            <IntroCmp />
            <FrameName/>
            <AboutMe />
            <MindsetComp />
            <SkillsComp />
            <ProjectComp />
            <ContactsComp />
            <FooterComp />
        </div>
    )
}

export default MainComponent;